var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MathOperator, MetricTriggerType, ThresholdOperator } from '@logz-pkg/enums';
import { Transform, Type } from 'class-transformer';
import { AlertOutputFormatColumnModel } from './alert-output-format-column';
import { AlertQueryModel } from './alert-query';
import { AlertSeverityThresholdModel } from './alert-severity-threshold';
import { alertModelManipulator } from './alert.manipulator';
export class SubComponentOutput {
    shouldUseAllFields = true;
    columns = [];
}
__decorate([
    Type(() => AlertOutputFormatColumnModel),
    __metadata("design:type", Array)
], SubComponentOutput.prototype, "columns", void 0);
export class LogTrigger {
    operator = MathOperator.GreaterThan;
    severityThresholdTiers = [new AlertSeverityThresholdModel()];
    riskScoreTiers;
}
__decorate([
    Transform(value => alertModelManipulator.convertSeverityThresholdTiersToRecord(value), { toPlainOnly: true }),
    Transform((value, obj) => alertModelManipulator.convertSeverityThresholdTiersToArray(value, obj.riskScoreTiers), {
        toClassOnly: true,
    }),
    __metadata("design:type", Array)
], LogTrigger.prototype, "severityThresholdTiers", void 0);
__decorate([
    Transform((value, obj) => alertModelManipulator.convertRiskScoreTiersToRecord(obj.severityThresholdTiers), {
        toPlainOnly: true,
    }),
    Transform(() => undefined, { toClassOnly: true }),
    __metadata("design:type", Object)
], LogTrigger.prototype, "riskScoreTiers", void 0);
export class SubComponentModel {
    queryDefinition = new AlertQueryModel();
    trigger = new LogTrigger();
    output = new SubComponentOutput();
}
__decorate([
    Type(() => AlertQueryModel),
    __metadata("design:type", AlertQueryModel)
], SubComponentModel.prototype, "queryDefinition", void 0);
__decorate([
    Type(() => LogTrigger),
    __metadata("design:type", LogTrigger)
], SubComponentModel.prototype, "trigger", void 0);
__decorate([
    Type(() => SubComponentOutput),
    __metadata("design:type", SubComponentOutput)
], SubComponentModel.prototype, "output", void 0);
export class MetricQueryDefinition {
    dataSource = '';
    promql = '';
}
export class MetricTrigger {
    triggerType = MetricTriggerType.THRESHOLD;
    metricOperator = ThresholdOperator.ABOVE;
    threshold = 0;
    minThreshold = 0;
    maxThreshold = 0;
    mathExpression = '';
}
export class MetricQueryModel {
    refId = 'A';
    queryDefinition = new MetricQueryDefinition();
}
__decorate([
    Type(() => MetricQueryDefinition),
    __metadata("design:type", MetricQueryDefinition)
], MetricQueryModel.prototype, "queryDefinition", void 0);
//# sourceMappingURL=sub-component.js.map